import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { COMMENTS_PAGE_SIZE } from '../constants'
import { commentRepository } from '../data-access/repositories/CommentRepository'

const base = ['comment']

export const commentQueryConfig = {
  list: (params: { contentTypeId: number; objectId: number }) => ({
    queryKey: buildQueryKey([
      ...base,
      'list',
      params.contentTypeId,
      params.objectId,
    ]),
    queryFn: () =>
      commentRepository.list({ ...params, pageSize: COMMENTS_PAGE_SIZE }),
  }),
}
